import {theme} from "antd";

export const getTheme = () => ({

    // generate CSS vars for all colors, including those auto-generated via the algorithm
    // view all in Dev Tools under class name .css-var-r0
    cssVar: true,
    algorithm: theme.defaultAlgorithm,

    // base token values
    token: {

        // standard colors
        colorBgBase:      "#f5f6f8",
        colorBgContainer: "white",
        colorBgLayout:    "#f5f6f8",
        colorTextBase:    "#334150",
        colorPrimary:     "#249af3",
        colorInfo:        "#249af3",
        colorLink:        "#249af3",
        colorBorder:      "#adb0b5",
        colorSplit:       "#adb0b5",
        colorBgElevated:  "#ffffff",

        // status colors
        colorError:   "#f33a3a",
        colorWarning: "#ffc512",
        colorSuccess: "#16d761",

        // brand colors - these are not used directly by the theme, but can apply with:
        // Option 1: Use CSS variable:
        //   color: var(--ant-color-brand-valor-blue);
        // Option 2: Use token:
        //   import {theme} from "antd"; const {token} = theme.useToken();
        //   <h1 style={{color: token.colorBrandValorBlue}}>…</h1>
        colorBrandValorBlue: "#0a2a57",
        colorBrandHonorBlue: "#00629e",
        colorBrandLightBlue: "#86b5ec",
        colorBrandYellow:    "#ffc512",
        colorBrandMagenta:   "#ec008c",
        colorBrandBlack:     "#334150",

        // component-specific colors
        colorContentFrameBg: "#f5f6f8",

        // other options
        borderRadius: 5,
        controlHeight: 32,
        fontFamily: "'Lato', sans-serif",
        fontFamilyCode: "monospace",
        fontSize: 14,
        lineType: "solid",
        lineWidth: 1,
        motion: false,
        motionBase: 0,

    },

    // overrides for specific components
    components: {
        Button: {
            primaryShadow: "none",
            colorTextDisabled: '#99A0A7',
            colorBgContainerDisabled: '#EBECED',
            borderColorDisabled: 'transparent',
        },
        Layout: {
            siderBg: "#f5f6f8",
        },
        Menu: {
            itemMarginInline: 0,
            itemMarginBlock: 5,
            itemPaddingInline: 10,
            itemBorderRadius: 10,
            itemFontSize: 16,
            itemBg:                   "white",
            itemSelectedBg:           "#249af3",
            itemSelectedColor:        "#ffffff",
            subMenuItemSelectedColor: "#495663",
        },
        Table: {
            headerBg: "transparent",
            headerColor: "#99A0A7",
            headerSplitColor: "transparent",
            cellPaddingBlock: 7,      // top/bottom for data cells
            cellPaddingInline: 10,
            rowHoverBg: 'transparent',
        },
        Card: {
            bodyPadding: 16,
        },
        Tooltip: {
            colorBgSpotlight: " #334150",
            fontSize: 12,
            // paddingSM: 4,
            // paddingXS: 4,
        },
    }

});
